import { Segment } from "#app/(unauthorized)/authentication/segment";
import type { NavRoutesConfig } from "#app/_ui/components/headers/nav-routes-config";

import filterHelper from "./filterHelper";
import type { NavRoutesConfigFilterParams } from "./filterNav";

export default function clientNavFilter({
  jwt,
  navRoutesConfig,
  requiredData,
}: NavRoutesConfigFilterParams): NavRoutesConfig {
  let result = navRoutesConfig;

  if (
    jwt.segment == Segment.IndividualInvestors ||
    jwt.segment == Segment.PrivateAssetManagement
  ) {
    let filtering = filterHelper(navRoutesConfig);

    if (requiredData.hasBairdResearch == false)
      filtering = filtering.removeRouteSubById(
        "InvestingTools",
        "InvestingToolsBairdResearch",
      );

    result = filtering.getFilteredRoutesConfig();
  }

  return result;
}
